<template>
  <div class="text-center fifth">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 30, 40,50]"
      :page-size="10"
	  :current-page.sync="index.PageIndex"
      layout="total, sizes, prev, pager, next, jumper"
      :total='count'>
    </el-pagination>

  </div>
</template>

<script>
    export default {
        name: "CommonPage",
        data(){
          return{
            
          }
        },
        props: ["count","index"],
        mounted(){
        },
        methods:{
          handleSizeChange(val){//
            this.$emit('pageSize',val)
          },
          handleCurrentChange(val){
            this.$emit('pageindex',val)
            window.scrollTo(0,0);
          }
        }
    }
</script>

<style scoped>

</style>
